import { ModalProps } from "antd/lib/modal/Modal";
import { Col, Input, message, Modal, Radio, Row } from "antd";
import Style from "./index.module.scss";
import React, { useContext, useImperativeHandle, useState } from "react";
import Form, { useForm } from "rc-field-form";
import "../../../../../style/public.scss";
import ChapterSelect from "../../../../../components/ChapterSelect";
import { Can, errorMessage } from "../../../../../service/service";
import { ResultMessage } from "../../../../../components/ResultMessage";
import FieldWithError from "../../../../../components/FieldWithError";
import { RowProps } from "antd/es/grid";
import GoChapter from "../GoChapter";
import {
    addCoursewareSourceForWebUrl,
    AddHrefProps
} from "../../../../../service/CourseDetail/resource";
import { CourseContext } from "../../../Store";
import useCurrentDate from "../../../../../utils/useCurrentDate";
import useRequestFn from "../../../../../utils/useRequestFn";
import classNames from "classnames";

interface DataModalInstance {
    setPayload: (payload: any) => void;
}

interface DataModalProps extends ModalProps {
    onOk?: () => void;
    onCancel?: () => void;
    onSuccess: () => void;
}

const RowAttr: RowProps = {
    gutter: 15,
    type: "flex",
    align: "middle",
    className: Style.row
};

interface FormProp {
    fileName: string;
    viewUrl: string;
    chapterId: string;
    isPublish: Can;
    description: string;
}

const HrefModal = React.forwardRef<DataModalInstance, DataModalProps>(
    ({ onSuccess, onOk, onCancel, ...props }, ref) => {
        const [payload, setPayload] = useState({});
        useImperativeHandle(ref, () => ({
            setPayload: payload => {
                setPayload(payload);
            }
        }));
        const [form] = useForm<FormProp>();
        const { course } = useContext(CourseContext);
        const { batchNo } = useCurrentDate();

        const [hrefAction, { loading }] = useRequestFn(
            addCoursewareSourceForWebUrl
        );
        async function onFinish(data: FormProp) {
            try {
                const params: AddHrefProps = {
                    sourceFileEntity: {
                        viewUrl: data.viewUrl,
                        fileName: data.fileName
                    },
                    batchNo,
                    courseNo: course.courseNo,
                    courseSeq: course.courseSeq,
                    chapterId: data.chapterId,
                    description: data.description,
                    isPublish: data.isPublish,
                    weektimeId: course.weekTimeId
                };
                hrefAction(params).then(res => {
                    message.success("添加网页链接成功");
                    onSuccess();
                });
            } catch (e) {
                ResultMessage.error(errorMessage(e));
            }
        }

        return (
            <Modal
                {...props}
                onCancel={onCancel}
                maskClosable={false}
                title="添加网页链接"
                onOk={form.submit}>
                <div className={Style.root}>
                    <Form form={form} onFinish={onFinish}>
                        <Row {...RowAttr}>
                            <Col span={5}>
                                <div className={Style.label}>标题：</div>
                            </Col>
                            <Col span={16}>
                                <FieldWithError name="fileName">
                                    <Input
                                        placeholder="请输入链接标题"
                                        maxLength={100}
                                    />
                                </FieldWithError>
                            </Col>
                        </Row>
                        <Row {...RowAttr} align="top">
                            <Col span={5}>
                                <div className="required_overflow label32">
                                    地址：
                                </div>
                            </Col>
                            <Col span={16}>
                                <FieldWithError
                                    name="viewUrl"
                                    rules={[
                                        {
                                            required: true,
                                            message: "请输入链接地址"
                                        },
                                        {
                                            pattern:
                                                /(http|https):\/\/([\w.]+\/?)\S*/,
                                            message:
                                                "请输入正确的链接地址，如：https://dufetea.edufe.com.cn"
                                        }
                                    ]}>
                                    <Input
                                        placeholder="请输入链接地址"
                                        maxLength={1000}
                                    />
                                </FieldWithError>
                            </Col>
                        </Row>
                        <Row {...RowAttr}>
                            <Col span={5}>
                                <div className={Style.label}>发布设置：</div>
                            </Col>
                            <Col span={16}>
                                <FieldWithError
                                    name="isPublish"
                                    initialValue={Can.no}>
                                    <Radio.Group>
                                        <Radio value={Can.no}>
                                            仅上传暂不发布
                                        </Radio>
                                        <Radio value={Can.yes}>
                                            上传并立即发布
                                        </Radio>
                                    </Radio.Group>
                                </FieldWithError>
                            </Col>
                        </Row>
                        <Row {...RowAttr}>
                            <Col span={5}>
                                <div className={Style.label}>所属章节：</div>
                            </Col>
                            <Col span={16}>
                                <FieldWithError
                                    name="chapterId"
                                    initialValue="0">
                                    <ChapterSelect />
                                </FieldWithError>
                            </Col>
                            <Col span={1}>
                                <GoChapter />
                            </Col>
                        </Row>
                        <Row {...RowAttr} align="top">
                            <Col span={5}>
                                <div
                                    className={classNames(
                                        Style.label,
                                        "label32"
                                    )}>
                                    课件说明：
                                </div>
                            </Col>
                            <Col span={16}>
                                <FieldWithError
                                    name="description"
                                    initialValue="">
                                    <Input.TextArea
                                        rows={4}
                                        maxLength={500}
                                        placeholder="输入课件说明，最多500字"
                                    />
                                </FieldWithError>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </Modal>
        );
    }
);

export default HrefModal;
